// extracted by mini-css-extract-plugin
module.exports = {"bp-min-md":"(min-width: 800px)","container":"VerifiedReviewsBlock-module--container--91982b","textContainer":"VerifiedReviewsBlock-module--textContainer--1252cb"};